import React, { useState, useEffect } from "react";
import st from "../../../style.module.scss";
import cx from "./Setting.module.scss";
import { NavLink, useHistory } from "react-router-dom";
import { Col, Row, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import bgimg from "../../../images/bg1.svg";
import edit from "../../../images/edit-img.svg";
import arrow from "../../../images/arrow.svg";
import Bottombar from "../../../components/Student/Bottombar/Bottombar";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Student/Footer/Footer";
import ProfileAvatar from "../../../Custom_Components/ProfileAvatar/ProfileAvatar";

export default function Setting() {
  let localData = JSON.parse(localStorage.getItem("userData")!);
  let token = localStorage.getItem("api_token")!
  const history = useHistory();

  useEffect(() => {
    if (token) {
      return;
    } else {
      history.push("/");
    }
  }, [])

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Header />
      <section className={`${st.pageContent}`}>
        <div className={`${st.leftContent}`}>
          <div className={`${cx.headerTitle}`}>
            <div className={`${cx.sticky}`}>
              <Row className={`${cx.titleBar}`}>
                <Col className={`col-2`}>
                </Col>
                <Col className={`col-8 ${cx.aboutUs}`}>
                  <h6>Setting</h6>
                </Col>
                <Col className={`col-2 text-end`}>
                </Col>
              </Row>
            </div>
            <img alt="profile" src={bgimg} className={`${cx.bgShape}`} />
          </div>

          <div className={`container ${cx.contentBody} mt-5`}>

            <Form className={`${cx.paddingLeft}`}>
              <Row>
                <Col className={`${cx.profileText}`}>
                  <NavLink to="/student/edit-profile" className={`${cx.userView}`}>
                    {localData?.image == "" || localData?.image == null ? <ProfileAvatar name={localData?.name} /> : <img alt="profile" src={localData?.image} className={`${cx.userImg}`} />}
                    <i className={`${cx.editIcon}`}><img alt="profile" src={edit} className={`${cx.editImg}`} /></i>
                  </NavLink>
                  <div className={`${cx.userText}`}>
                    <h5>{localData?.name}</h5>
                    <p>{localData?.email}</p>
                  </div>
                </Col>
              </Row>
            </Form>
            <Row className={`${cx.bottomPadding}`}>
              <Col lg={6} className={`${cx.paddingBottom}`}>
                <NavLink to="/student/payment-history" className={`${cx.nextPage}`}>
                  <h6>Payment History</h6>
                  <img alt='' src={arrow} className={`${cx.arrowImg}`} />
                </NavLink>
              </Col>
              <Col lg={6} className={`${cx.paddingBottom}`}>
                <NavLink to="/student/referral-rewards" className={`${cx.nextPage}`}>
                  <h6>Referral & Offers</h6>
                  <img alt='rewards' src={arrow} className={`${cx.arrowImg}`} />
                </NavLink>
              </Col>
              <Col lg={6} className={`${cx.paddingBottom}`}>
                <NavLink to="/student/change-your-password" className={`${cx.nextPage}`}>
                  <h6>Change Password</h6>
                  <img alt='password' src={arrow} className={`${cx.arrowImg}`} />
                </NavLink>
              </Col>
              <Col lg={6} className={`${cx.paddingBottom}`}>
                <NavLink to="/student/about-us" className={`${cx.nextPage}`}>
                  <h6>About Us</h6>
                  <img alt='aboutUs' src={arrow} className={`${cx.arrowImg}`} />
                </NavLink>
              </Col>
              <Col lg={6} className={`${cx.paddingBottom}`}>
                <NavLink to="/student/privacy-policy" className={` ${cx.nextPage}`}>
                  <h6>Privacy Policy</h6>
                  <img alt='policy' src={arrow} className={`${cx.arrowImg}`} />
                </NavLink>
              </Col>
              <Col lg={6} className={`${cx.paddingBottom}`}>
                <NavLink to="/student/terms-and-conditions" className={`${cx.nextPage}`}>
                  <h6>Terms and conditions</h6>
                  <img alt='terms' src={arrow} className={`${cx.arrowImg}`} />
                </NavLink>
              </Col>
              <Col lg={6} className={`${cx.paddingBottom}`}>
                <NavLink to="/student/help-and-support" className={`${cx.nextPage}`}>
                  <h6>Help and Support</h6>
                  <img alt='' src={arrow} className={`${cx.arrowImg}`} />
                </NavLink>
              </Col>
              <Col lg={6} className={`${cx.paddingBottom}`}>
                <NavLink to="#" onClick={handleShow} className={`${cx.nextPage}`}>
                  <h6>Logout</h6>
                  <img alt='' src={arrow} className={`${cx.arrowImg}`} />
                </NavLink>
              </Col>
            </Row>
          </div>
          <div className={`pt-3 ${st.spaceBox}`}></div>
          <Bottombar />
        </div>
      </section>
      <Footer />
      <div
        className={`${cx.popupBox} ${show && cx.popupShow}`}>
        <div className={`${cx.bgBox}`}></div>
        <div className={`${cx.popupBoxBody}`}>
          <div className={`${cx.cotentBody}`}>
            <Row>
              <Col className="col-12">
                <h5>Do you want to logout?</h5>
              </Col>
              <Col className="col-12">
                <NavLink to="#" className={`btn border-end ${cx.actionBtn}`} onClick={handleClose}>
                  NO
                </NavLink>
                <NavLink to="/" className={`btn ${cx.actionBtn}`}
                  onClick={() => {
                    localStorage.removeItem("api_token");
                    localStorage.removeItem("userData");
                  }}>
                  YES
                </NavLink>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}